export default __webpack_public_path__ + "static/her-0055e974f07539329e35de7e2327b155.png";